import React, {useState, useEffect} from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {connect} from 'react-redux';
import SongListForDownload from '../Shared/SongListForDownload/SongListForDownload';
import {setTitle, setSelectedCategory, pageLoaded} from '../fundialSlice';
import Search from '../Shared/Search/search';

const SongListPage = (props) => {

  useExtendedEffect((runSideEffects) => { 
    window.scrollTo(0, 0);

    if (runSideEffects()) {
      props.setTitle({titleBold: props.selectedCategory.title , titleRegular: ""})
      props.pageLoaded();
    }
  }, []);

  return (
    <div className='song-list-page'>
        <Search></Search>
        <SongListForDownload items={props.catagories[props.selectedCategory.id].items} />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    catagories: state.fundialPage.catagories,
    selectedCategory : state.fundialPage.pages.songListPage.selectedCategory,
  };
};

const mapDispatchToProps = {
  setTitle,
  setSelectedCategory,
  pageLoaded
};

export default connect(mapStateToProps, mapDispatchToProps)(SongListPage);
